export default {"src":"/_next/static/media/parsley.e317994a.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};